import { gql } from '@apollo/client';
import PATIENT_FRAGMENT from '../fragments/patientFragment';
import PATIENT_ONBOARDING_FRAGMENT from '../fragments/patientOnBoardingFragment';

const DELETED_STUDY_QUERY = gql`
  query deletedStudy($id: ID!) {
    deletedStudy(id: $id) {
      id
      onboarding {
        ...PatientOnBoardingFragment
      }
      info {
        patient {
          ...PatientFragment
        }
        diagnosis {
          primary
          second
          physiciansNote
          patientMedications
        }
        insurance {
          type
          provider
          preAuth
        }
        interprettingPhysician {
          id
          firstName
          lastName
          contact {
            phone1
            nightPhone
            fax
          }
          email
        }
        referringPhysician {
          id
          firstName
          lastName
          contact {
            phone1
            nightPhone
            fax
          }
          email
        }
      }
    }
  }

  ${PATIENT_FRAGMENT}
  ${PATIENT_ONBOARDING_FRAGMENT}
`;

export default DELETED_STUDY_QUERY;
